import spy from './spy.json';
import qqq from './qqq.json';
import gld from './gld.json';
import spyGld5050 from './spy-gld-50-50.json';

export const benchmarks = {
  spy,
  qqq,
  gld,
  'spy-gld-50-50': spyGld5050,
};

export { spy, qqq, gld, spyGld5050 };

export default benchmarks;
